/**
 * Returns a unique MQTT clientId built from a stable, log-friendly prefix and
 * a random suffix.
 *
 * MQTT allows exactly ONE live connection per clientId: when a second
 * connection presents the same id, the broker disconnects the first (a
 * "session takeover"). Reusing a fixed device code as the clientId across
 * multiple concurrent connections made every new connection kick a previous
 * one, and auto-reconnecting kicked clients then fought back — escalating
 * into broker-wide connect storms (millions of CONNACKs/day observed at a
 * mill). A unique suffix per connection makes takeovers structurally
 * impossible while the prefix keeps broker logs attributable to a device.
 *
 * Math.random (rather than crypto.randomUUID) keeps this safe on older
 * tablet webviews.
 */
export const uniqueClientId = (prefix: string): string =>
    `${prefix}-${Math.random().toString(16).slice(2, 10)}`;
